export default {
  init() {
    // JavaScript to be fired on all pages

    $('.wp-block-gallery .blocks-gallery-grid').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      adaptiveHeight: true,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleBlog.js